export enum FormulasOptions {
  OBJVAL = "OBJVAL",
  VELO = "VELO", //Bris et vol des vélos en tout lieu
  RCS = "RCS", //Assurance scolaire
  PJ = "PJ", //Protection juridique
  OPIS = "OPIS", //Piscine
  ANO = "ANO", //Assurance des objets nomades
  PJSOL = "PJSOL", //Protection juridique solidaire
  VAN = "VAN", //Valeur à neuf
  DOMX = "DOMX", //Dommages électriques
  ROV = "ROV", //Renforcement Objet de Valeur
  RPM = "RPM", //Renforcement Patrimoine Mobilier
  BDG = "BDG", //Bris de glace
  VLX = "VLX", //Vol de véhicules terrestres à moteur
  OPT_AEXT = "OPT_AEXT", //Assurance des biens extérieurs
}
